




























































































import { default as moment } from "moment-timezone";
import { TIMEZONE } from "@/api/Termine";
import { TOTP, Secret } from "otpauth";
import { Component, Prop, Vue } from "vue-property-decorator";
import { default as MySignaturePadVue } from "./MySignaturePad.vue";
import { default as QRCode } from "./QRCode.vue";
Vue.component("QRCode", QRCode);
//Vue.use(vueQriousjs);

@Component({
  name: "HelloWorld",
  components: {
    MySignaturePad: MySignaturePadVue,
    //'Calendar': Calendar,
  },
})
export default class HelloWorld extends Vue {
  @Prop() private msg!: string;
  public config = {
    value: "https://github.com/neocotic/qrious",
  };
  public secret = "";
  public code = "";
  public issuer = "ZNA GmbH";
  public name = "đuro";
  public codelength = 6;
  public period = 30;
  public validationcode = "";
  public validationresult = "Bitte Überprüfungscode eingeben";
  public validationresultCss = "pi pi-refresh";
  mounted() {
    const STORAGE_KEY_CODE = "qr-secret-key";
    const storage = localStorage || window.localStorage;
    if (storage) {
      const storedCode = storage.getItem(STORAGE_KEY_CODE);
      if (storedCode) {
        this.secret = storedCode;
        this.regenerateCode();
        return;
      }
    }
    this.secret = new Secret().b32;
    if (storage) {
      storage.setItem(STORAGE_KEY_CODE, this.secret);
    }
    this.regenerateCode();
  }
  regenerateCode() {
    this.config.value = new TOTP({
      issuer: this.issuer,
      label: this.name,
      secret: this.secret,
      digits: this.codelength,
      period: this.period,
    }).toString();
    //this.$refs.qrcode.
  }
  validate(event: any) {
    const validator = new TOTP({
      issuer: this.issuer,
      label: this.name,
      secret: this.secret,
      digits: this.codelength,
      period: this.period,
    });
    const result = validator.validate({ token: event.target?.value });
    this.validationresult =
      "Code ist " + (0 == result ? "" : "nicht ") + "korrekt";
    this.validationresultCss =
      "pi " + (0 == result ? "pi-check-circle" : "pi-times-circle");
  }
  cw(d = new Date(2022, 0, 2, 12)) {
    function kalenderwoche(date: string) {
        console.debug(`Bestimme Kalenderwoche: ${date}`);
        if (date == undefined) {
          return 'KW undefined';
        }

        const tagInWoche = moment(date).tz(TIMEZONE);
        tagInWoche.subtract(tagInWoche.isoWeekday() - 1, 'day');
        console.debug(`Wochentag: ${tagInWoche.isoWeekday()}`);
        const kw = tagInWoche.format('YYYY/WW');
        console.debug(`Ermittelte Kalenderwoche: ${kw}`);
        return kw;
    }
    return d.toDateString() + " => " + kalenderwoche(d.toISOString());
  }
}
